var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"master-account-restriction"},[_c('div',{staticClass:"master-account-restriction__link"},[_c('span',{staticClass:"icon-link-new"})]),_c('h3',[_vm._v("Реферальные ссылки")]),_c('p',[_vm._v(" Переключитесь на нижний аккаунт, чтобы использовать реферальные ссылки ")])])
}]

export { render, staticRenderFns }